import { render, staticRenderFns } from "./CatapultBannerApp.vue?vue&type=template&id=d2724b7a"
import script from "./CatapultBannerApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatapultBannerApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CatapultBannerApp.vue?vue&type=style&index=0&id=d2724b7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports